(function(Index, $, undefined) {

  var video = $('#index-video').get(0);

  var initWaypoints = function() {
    const headerOffset = $('.site-header').outerHeight();
    const navOffset = $('[data-scroll-nav]').outerHeight();
    const waypointOffset = headerOffset + navOffset;

    $('[data-toggle-floating-button]').waypoint(function() {
      $('.floating-btn').toggleClass('floating-btn--visible');
      $('.share-widget').toggleClass('share-widget--visible');
    }, {
      offset: Variables.headerHeight
    });

    // if ($(window).width() >= 1024) {
    //   $('[data-waypoint-nav-toggle]').waypoint(function(direction) {
    //     $('.section-menu-nav').toggleClass('section-menu-nav--sticky');
    //   }, {
    //     offset: Variables.getSectionNavOffset()
    //   }); 
    // }
  }

  var inlineVideo = function() {
    enableInlineVideo(video);
  }

  var bindUIActions = function() {
    $('[data-tab]').on('click', function(e) {
      const tabIndex = $(this).attr('data-tab');

      e.preventDefault();
      $(this).closest('.tabs').find('.tabs__content-wrapper').hide();
      $(this).closest('.tabs').find('.tabs__content-wrapper[data-tab-index="' + tabIndex + '"]').show();
    });

    $('[data-toggle-section-modal]').on('click', function() {
      $(this).closest('.feature-summary').find('.feature-summary__modal').toggleClass('feature-summary__modal--active');
      if ($(window).width() < 1024) {
        $('body').toggleClass('modal-open scroll-lock');
      }
    });

    $(document).on('click', '[data-section-menu-btn]' , function() {
      Scroll.pauseWaypointFunctions = true;
      $('.section-menu__btn').removeClass('section-menu__btn--active');
      $(this).addClass('section-menu__btn--active');
    });

    $(document).on('click', '[data-play-hero-video]' , function() {
      $(this).closest('.cta-hero').addClass('cta-hero--playing');
      video.play();
      video.onended = function(e) {
        video.load();
        $(this).closest('.cta-hero').removeClass('cta-hero--playing');
      };
    });
  }

  // Public
  Index.init = function() {
    bindUIActions();
    initWaypoints();
    inlineVideo();
  };

}(window.Index = window.Index || {}, jQuery));